import http from "./http";

const getAdmin = (params, cancelToken) => {
  return http.get("/admins", {
    params,
    cancelToken,
  });
};

const createAdmin = (data) => {
  return http.post("/admins", data);
};

const removeAdmin = (id) => {
  return http.delete("/admins", { 
    params: { user_id: id }
  });
};

const updateAdmin = (data) => {
  return http.put(`/admins`, data);
};

export default {
  getAdmin,
  createAdmin,
  updateAdmin,
  removeAdmin
};
